import Pikaday from "pikaday";

export default class DatePicker {
    constructor(matchMediaQuery) {
        this.datePickers = document.querySelectorAll(".js-date-picker");
        this.createdDatepickers = [];
        this.matchMediaQuery = matchMediaQuery;
        this.setNumberOfMonths();
        this.bindDatePickers();
    }

    setNumberOfMonths() {
        if (this.matchMediaQuery.matches) {
            this.numberOfMonths = 1;
        } else {
            this.numberOfMonths = 2;
        }
    }

    bindDatePickers() {
        this.matchMediaQuery.addListener((event) => {
            if (event.matches) {
                this.numberOfMonths = 1;
            } else {
                this.numberOfMonths = 2;
            }
        });

        this.datePickers.forEach((datePickerEl) => {
            const parentElement = datePickerEl.closest(".js-date-picker-ct");
            const datePickerButton = parentElement.querySelector("button");

            this.bindDatePickerElement(datePickerEl, parentElement);
            this.bindDatePickerButton(datePickerButton, parentElement);
            this.configureDatePicker(datePickerEl, parentElement);
        });
    }

    bindDatePickerElement(datePickerEl, parentElement) {
        datePickerEl.addEventListener("focus", () => {
            parentElement.classList.add("b-item-selected");
        });

        datePickerEl.addEventListener("blur", () => {
            parentElement.classList.remove("b-item-selected");
        });
    }

    bindDatePickerButton(datePickerButton, parentElement) {
        datePickerButton.addEventListener("focus", () => {
            parentElement.classList.add("b-item-selected");
        });

        datePickerButton.addEventListener("blur", () => {
            parentElement.classList.remove("b-item-selected");
        });
    }

    configureDatePicker(datePickerEl, parentElement) {
        datePickerEl.pikaday = new Pikaday({
            field: datePickerEl,
            trigger: parentElement,
            numberOfMonths: this.numberOfMonths,
            format: "YYYY/MM/DD",
            container: parentElement,
            minDate: new Date(datePickerEl.dataset.mindate) || null,
            maxDate: new Date(datePickerEl.dataset.maxdate) || null,
            toString: (date) => {
                let month = `${date.getMonth() + 1}`;
                let day = `${date.getDate()}`;
                const year = date.getFullYear();

                if (month.length < 2) month = `0${month}`;
                if (day.length < 2) day = `0${day}`;

                return [year, month, day].join("-");
            },
            onSelect: (date) => {
                if (!datePickerEl.classList.contains("js-start-date")) {
                    return;
                }
                const endPickerEl = document.querySelector(".js-end-date");
                if (!endPickerEl) {
                    return;
                }

                const dateObj = new Date(date);
                let selectedDate = endPickerEl.pikaday.getDate();

                endPickerEl.pikaday = document.querySelector(".js-end-date").pikaday;

                if (datePickerEl.dataset.weekly) {
                    endPickerEl.pikaday.setMinDate(date);

                    dateObj.setDate(dateObj.getDate() + 6);

                    endPickerEl.pikaday.setMaxDate(dateObj);
                    endPickerEl.pikaday.setDate(dateObj);
                } else {
                    if (selectedDate !== null && selectedDate < dateObj) {
                        endPickerEl.pikaday.setDate(dateObj);
                        endPickerEl.pikaday.setMinDate(dateObj);
                    }
                }

            },
        });

        this.createdDatepickers.push(datePickerEl.pikaday);
    }

    getCreatedDatepickers() {
        return this.createdDatepickers;
    }
}
